import React from 'react';
import {
  ICustomerForTable,
  ICustomerWithPhones,
} from '../../../../../store/reducers/enhancedCustomerSearch/types';
import { CustomerInput } from '../../../../../components/formControls/CustomerInput/CustomerInput';
import { isCustomerFieldLocked } from '../CustomerSearchTable/helpers';
import { TruncatedText } from '../../../../../components/TruncatedText/TruncatedText';

type TCustomerInputFieldProps = {
  editingElement: ICustomerWithPhones | null;
  isEdit: boolean;
  fieldName: keyof ICustomerForTable;
  customer: ICustomerWithPhones;
  onFieldChange: (
    fieldName: keyof ICustomerForTable
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  textMaxWidth?: number;
};

const toDisplayValue = (value: unknown): string =>
  typeof value === 'string' || typeof value === 'number' ? String(value) : '';

export const CustomerInputField: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<TCustomerInputFieldProps>>
> = ({ editingElement, isEdit, onFieldChange, fieldName, customer, textMaxWidth }) => {
  // profile type is resolved from the original customer row, not from unsaved edits
  const isFieldLocked = isCustomerFieldLocked(fieldName, customer);

  return isEdit &&
    editingElement?.vehicleId === customer.vehicleId &&
    editingElement?.customerId === customer.customerId ? (
    <CustomerInput
      value={editingElement[fieldName] ?? ''}
      onChange={onFieldChange(fieldName)}
      disabled={isFieldLocked}
    />
  ) : (
    <TruncatedText
      key={fieldName}
      text={toDisplayValue(customer[fieldName])}
      maxWidth={textMaxWidth}
    />
  );
};
